import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import Document16Icon from '@atlaskit/icon-file-type/glyph/document/16';
import { N20A } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/design-system/prefer-primitives, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
export var UrlIcon = styled.div(function (props) {
  var _props$url;
  return {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundImage: "url(".concat((_props$url = props.url) !== null && _props$url !== void 0 ? _props$url : '', ")"),
    backgroundColor: "var(--ds-skeleton, ".concat(N20A, ")"),
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    height: "var(--ds-space-200, 16px)",
    width: "var(--ds-space-200, 16px)",
    borderRadius: "var(--ds-border-radius, 3px)",
    flexShrink: 0
  };
});
export var PageIcon = function PageIcon() {
  return /*#__PURE__*/React.createElement(Document16Icon, {
    label: "Page"
  });
};